import {
    Directive,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    Renderer2,
    SimpleChanges,
} from '@angular/core';

@Directive({
    selector: '[hamBadge]',
})
export class HamBadgeDirective implements OnInit, OnDestroy, OnChanges {
    @Input() icon: string | null = null;
    @Input() color: 'primary' | 'green' | 'yellow' | 'purple' | 'red' | 'magenta' | 'grey' | 'grey2' | 'indigo' =
        'primary';
    @Input() size: 'small' | 'large' = 'small';
    @Input() hasCancelIcon: boolean = false;
    @Output() cancel = new EventEmitter<void>();

    private textElementWrapper: HTMLElement;
    private iconElementWrapper: HTMLElement;
    private iconElement: HTMLElement;
    private cancelIconElementWrapper: HTMLElement;
    private cancelIconElement: HTMLElement;
    private listeners: (() => void)[] = [];

    constructor(private el: ElementRef, private renderer: Renderer2) {}

    ngOnInit() {
        this.setBadgeStyles();

        // Create a wrapper for the text content
        this.textElementWrapper = this.renderer.createElement('span');
        this.renderer.addClass(this.textElementWrapper, 'badge-text');

        // Move existing content (text) inside the text wrapper
        const textContent = this.el.nativeElement.childNodes;
        textContent.forEach((node) => this.renderer.appendChild(this.textElementWrapper, node));

        // Add the icon if provided
        if (this.icon) {
            this.iconElementWrapper = this.renderer.createElement('span');
            this.renderer.addClass(this.iconElementWrapper, 'ham-icon');
            this.iconElement = this.renderer.createElement('i');
            this.renderer.addClass(this.iconElement, 'badge-icon');
            this.renderer.setStyle(this.iconElement, 'mask-image', `url(${this.icon})`);
            this.renderer.setStyle(this.iconElement, '-webkit-mask-image', `url(${this.icon})`);
            this.renderer.appendChild(this.iconElementWrapper, this.iconElement);
            this.renderer.appendChild(this.el.nativeElement, this.iconElementWrapper);
        }

        // Add text wrapper after icon
        this.renderer.appendChild(this.el.nativeElement, this.textElementWrapper);

        // Add the cancel icon if required
        if (this.hasCancelIcon) {
            this.cancelIconElementWrapper = this.renderer.createElement('span');
            this.renderer.addClass(this.cancelIconElementWrapper, 'ham-icon');
            this.cancelIconElement = this.renderer.createElement('i');
            this.renderer.addClass(this.cancelIconElement, 'badge-cancel-icon');
            this.listeners.push(this.renderer.listen(this.cancelIconElement, 'click', () => this.onCancel()));
            this.renderer.appendChild(this.cancelIconElementWrapper, this.cancelIconElement);
            this.renderer.appendChild(this.el.nativeElement, this.cancelIconElementWrapper);
        }
    }

    ngOnDestroy() {
        // Clean up listeners
        this.listeners.forEach((listener) => listener());
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['color'] && !changes['color'].firstChange) {
            this.updateBadgeColor(changes['color'].previousValue, changes['color'].currentValue);
        }
    }

    private setBadgeStyles() {
        this.renderer.addClass(this.el.nativeElement, 'ham-badge');
        this.renderer.addClass(this.el.nativeElement, `badge-${this.color}`);
        this.renderer.addClass(this.el.nativeElement, `badge-${this.size}`);
    }

    private updateBadgeColor(previousColor: string, newColor: string) {
        // Remove the previous color class
        this.renderer.removeClass(this.el.nativeElement, `badge-${previousColor}`);
        // Add the new color class
        this.renderer.addClass(this.el.nativeElement, `badge-${newColor}`);
    }

    onCancel() {
        this.cancel.emit();
    }
}
